module.exports = "<div class=\"page-load-animation\"></div>\n<router-outlet></router-outlet>\n"